import type { FluxElementDto } from "@/app/dto/flux-element.dto.ts";
import { useDownstreamApi } from "@/app/http/downstream.api.ts";
import { useUpstreamApi } from "@/app/http/upstream.api.ts";
import { AlertDuration, AlertType, useAlertManager } from "@pasta/box-v2";
import { genderize, useGenderize } from "./gender";

export async function seeAgainUpstream(lfId: number, element: FluxElementDto) {
  await seeAgain(element, () => useUpstreamApi().seeAgain(lfId, element.id));
}

export async function seeAgainDownstream(lfId: number, element: FluxElementDto) {
  await seeAgain(element, () => useDownstreamApi().seeAgain(lfId, element.id));
}

async function seeAgain(element: FluxElementDto, invite: () => Promise<void>) {
  if (!confirmIfAbsent(element)) return;

  await invite();
  useAlertManager().createAlert({
    type: AlertType.INFO,
    duration: AlertDuration.LONG,
    message: `${element.name} a été invité à revoir le Parapheur`,
  });
}

function confirmIfAbsent(element: FluxElementDto) {
  if (!element.absence) return true;

  const genderizeMe = useGenderize();
  return confirm(
    `${element.name} est ${genderize("absent", element.civility)}. Êtes-vous ${genderizeMe("sûr")} de vouloir l’inviter à revoir ce parapheur ?`
  );
}
